import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { StoryData } from '@storyblok/react'
import { atomStoryblokComponents } from '../../data-maps/atom-storyblok-components-map'
import styles from './finance-representative-reference.module.css'

export interface FinanceRepresentativeReferenceProps {
  financeRepresentativeExample?: StoryData[]
}

export function FinanceRepresentativeReference({
  financeRepresentativeExample,
}: FinanceRepresentativeReferenceProps) {
  const financeRepresentative = financeRepresentativeExample ?? []

  if (financeRepresentative.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      <StoryblokRenderer
        block={financeRepresentative[0]?.content}
        components={atomStoryblokComponents}
        props={{ financeRepresentativeExample: financeRepresentative }}
      />
    </div>
  )
}
